
shadow$export("default",orgx.build_a_clojurescript_application_running_on_node_using_nix.component);
shadow$export("component",orgx.build_a_clojurescript_application_running_on_node_using_nix.component);